// Package assets.v3 defines the protocol buffer messages and services for asset management
// within the platform. This includes asset upload, processing, and retrieval operations.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file assets/v3/asset_service.proto (package assets.v3, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { AccessType } from "../../authz/v3/authz_pb";
import { file_authz_v3_authz } from "../../authz/v3/authz_pb";
import type { Asset, AssetLifecycleState } from "./asset_pb";
import { file_assets_v3_asset } from "./asset_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file assets/v3/asset_service.proto.
 */
export const file_assets_v3_asset_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v3_common, file_authz_v3_authz, file_assets_v3_asset, file_google_protobuf_timestamp]);

/**
 * @generated from message assets.v3.GenerateSignedURLRequest
 */
export type GenerateSignedURLRequest = Message<"assets.v3.GenerateSignedURLRequest"> & {
  /**
   * The ID of the asset to generate a signed URL for
   *
   * @generated from field: string asset_id = 1;
   */
  assetId: string;
};

/**
 * Describes the message assets.v3.GenerateSignedURLRequest.
 * Use `create(GenerateSignedURLRequestSchema)` to create a new message.
 */
export const GenerateSignedURLRequestSchema: GenMessage<GenerateSignedURLRequest> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 0);

/**
 * @generated from message assets.v3.GenerateSignedURLResponse
 */
export type GenerateSignedURLResponse = Message<"assets.v3.GenerateSignedURLResponse"> & {
  /**
   * The signed URL for uploading the asset
   *
   * @generated from field: string signed_url = 1;
   */
  signedUrl: string;
};

/**
 * Describes the message assets.v3.GenerateSignedURLResponse.
 * Use `create(GenerateSignedURLResponseSchema)` to create a new message.
 */
export const GenerateSignedURLResponseSchema: GenMessage<GenerateSignedURLResponse> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 1);

/**
 * Base message containing asset data and available actions
 *
 * @generated from message assets.v3.AssetWithActions
 */
export type AssetWithActions = Message<"assets.v3.AssetWithActions"> & {
  /**
   * The asset data
   *
   * @generated from field: assets.v3.Asset data = 1;
   */
  data: Asset;

  /**
   * List of actions the caller is authorized to perform on this asset
   *
   * @generated from field: repeated authz.v3.AccessType actions = 2;
   */
  actions: AccessType[];
};

/**
 * Describes the message assets.v3.AssetWithActions.
 * Use `create(AssetWithActionsSchema)` to create a new message.
 */
export const AssetWithActionsSchema: GenMessage<AssetWithActions> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 2);

/**
 * Request message for creating a new asset.
 *
 * @generated from message assets.v3.CreateAssetRequest
 */
export type CreateAssetRequest = Message<"assets.v3.CreateAssetRequest"> & {
  /**
   * Original filename as provided by the user
   *
   * @generated from field: string original_filename = 1;
   */
  originalFilename: string;

  /**
   * Size of the file in bytes
   *
   * @generated from field: int64 file_size = 2;
   */
  fileSize: bigint;

  /**
   * MIME type of the file
   *
   * @generated from field: string content_type = 3;
   */
  contentType: string;

  /**
   * Display name for the asset
   *
   * @generated from field: string display_name = 4;
   */
  displayName: string;

  /**
   * @generated from field: string md5_hash = 5;
   */
  md5Hash: string;

  /**
   * @generated from field: string project_id = 6;
   */
  projectId: string;
};

/**
 * Describes the message assets.v3.CreateAssetRequest.
 * Use `create(CreateAssetRequestSchema)` to create a new message.
 */
export const CreateAssetRequestSchema: GenMessage<CreateAssetRequest> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 3);

/**
 * Response message for creating a new asset.
 *
 * @generated from message assets.v3.CreateAssetResponse
 */
export type CreateAssetResponse = Message<"assets.v3.CreateAssetResponse"> & {
  /**
   * The created asset with available actions
   *
   * @generated from field: assets.v3.AssetWithActions asset = 1;
   */
  asset: AssetWithActions;

  /**
   * Upload strategy used for this asset
   *
   * @generated from field: string upload_strategy = 2;
   */
  uploadStrategy: string;

  /**
   * Signed URL for uploading large files (if applicable)
   *
   * @generated from field: optional string upload_url = 3;
   */
  uploadUrl: string;

  /**
   * Required headers for the upload request (if applicable)
   *
   * @generated from field: map<string, string> upload_headers = 4;
   */
  uploadHeaders: { [key: string]: string };

  /**
   * When the upload URL expires (if applicable)
   *
   * @generated from field: optional google.protobuf.Timestamp expires_at = 5;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message assets.v3.CreateAssetResponse.
 * Use `create(CreateAssetResponseSchema)` to create a new message.
 */
export const CreateAssetResponseSchema: GenMessage<CreateAssetResponse> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 4);

/**
 * Request message for retrieving a specific asset.
 *
 * @generated from message assets.v3.GetAssetRequest
 */
export type GetAssetRequest = Message<"assets.v3.GetAssetRequest"> & {
  /**
   * The ID of the asset to retrieve
   *
   * @generated from field: string asset_id = 1;
   */
  assetId: string;
};

/**
 * Describes the message assets.v3.GetAssetRequest.
 * Use `create(GetAssetRequestSchema)` to create a new message.
 */
export const GetAssetRequestSchema: GenMessage<GetAssetRequest> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 5);

/**
 * Response message for retrieving a specific asset.
 *
 * @generated from message assets.v3.GetAssetResponse
 */
export type GetAssetResponse = Message<"assets.v3.GetAssetResponse"> & {
  /**
   * The asset data with available actions
   *
   * @generated from field: assets.v3.AssetWithActions asset = 1;
   */
  asset: AssetWithActions;
};

/**
 * Describes the message assets.v3.GetAssetResponse.
 * Use `create(GetAssetResponseSchema)` to create a new message.
 */
export const GetAssetResponseSchema: GenMessage<GetAssetResponse> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 6);

/**
 * Request message for retrieving multiple assets by their IDs.
 *
 * @generated from message assets.v3.GetAssetsRequest
 */
export type GetAssetsRequest = Message<"assets.v3.GetAssetsRequest"> & {
  /**
   * The IDs of the assets to retrieve (max 100)
   *
   * @generated from field: repeated string asset_ids = 1;
   */
  assetIds: string[];
};

/**
 * Describes the message assets.v3.GetAssetsRequest.
 * Use `create(GetAssetsRequestSchema)` to create a new message.
 */
export const GetAssetsRequestSchema: GenMessage<GetAssetsRequest> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 7);

/**
 * Response message for retrieving multiple assets.
 *
 * @generated from message assets.v3.GetAssetsResponse
 */
export type GetAssetsResponse = Message<"assets.v3.GetAssetsResponse"> & {
  /**
   * The list of assets with their available actions
   *
   * @generated from field: repeated assets.v3.AssetWithActions assets = 1;
   */
  assets: AssetWithActions[];

  /**
   * List of asset IDs that were not found or inaccessible
   *
   * @generated from field: repeated string not_found_asset_ids = 2;
   */
  notFoundAssetIds: string[];
};

/**
 * Describes the message assets.v3.GetAssetsResponse.
 * Use `create(GetAssetsResponseSchema)` to create a new message.
 */
export const GetAssetsResponseSchema: GenMessage<GetAssetsResponse> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 8);

/**
 * Request message for listing assets with pagination.
 *
 * @generated from message assets.v3.ListAssetsRequest
 */
export type ListAssetsRequest = Message<"assets.v3.ListAssetsRequest"> & {
  /**
   * The maximum number of assets to return
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * The next_page_token value returned from a previous List request, if any
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * Optional filter by lifecycle state
   *
   * @generated from field: repeated assets.v3.AssetLifecycleState lifecycle_states = 3;
   */
  lifecycleStates: AssetLifecycleState[];

  /**
   * @generated from field: string organization_id = 4;
   */
  organizationId: string;

  /**
   * @generated from field: string tenant_id = 5;
   */
  tenantId: string;

  /**
   * @generated from field: string workspace_id = 6;
   */
  workspaceId: string;

  /**
   * Optional filter by project ID
   *
   * @generated from field: string project_id = 7;
   */
  projectId: string;
};

/**
 * Describes the message assets.v3.ListAssetsRequest.
 * Use `create(ListAssetsRequestSchema)` to create a new message.
 */
export const ListAssetsRequestSchema: GenMessage<ListAssetsRequest> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 9);

/**
 * Response message for listing assets.
 *
 * @generated from message assets.v3.ListAssetsResponse
 */
export type ListAssetsResponse = Message<"assets.v3.ListAssetsResponse"> & {
  /**
   * The list of assets with their available actions
   *
   * @generated from field: repeated assets.v3.AssetWithActions assets = 1;
   */
  assets: AssetWithActions[];

  /**
   * Token to retrieve the next page of results
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message assets.v3.ListAssetsResponse.
 * Use `create(ListAssetsResponseSchema)` to create a new message.
 */
export const ListAssetsResponseSchema: GenMessage<ListAssetsResponse> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 10);

/**
 * Request message for updating an asset.
 *
 * @generated from message assets.v3.UpdateAssetRequest
 */
export type UpdateAssetRequest = Message<"assets.v3.UpdateAssetRequest"> & {
  /**
   * The asset information to update
   *
   * @generated from field: assets.v3.Asset asset = 1;
   */
  asset: Asset;
};

/**
 * Describes the message assets.v3.UpdateAssetRequest.
 * Use `create(UpdateAssetRequestSchema)` to create a new message.
 */
export const UpdateAssetRequestSchema: GenMessage<UpdateAssetRequest> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 11);

/**
 * Response message for updating an asset.
 *
 * @generated from message assets.v3.UpdateAssetResponse
 */
export type UpdateAssetResponse = Message<"assets.v3.UpdateAssetResponse"> & {
  /**
   * The updated asset with available actions
   *
   * @generated from field: assets.v3.AssetWithActions asset = 1;
   */
  asset: AssetWithActions;
};

/**
 * Describes the message assets.v3.UpdateAssetResponse.
 * Use `create(UpdateAssetResponseSchema)` to create a new message.
 */
export const UpdateAssetResponseSchema: GenMessage<UpdateAssetResponse> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 12);

/**
 * @generated from message assets.v3.DeleteAssetsRequest
 */
export type DeleteAssetsRequest = Message<"assets.v3.DeleteAssetsRequest"> & {
  /**
   * The IDs of the assets to delete (max 100)
   *
   * @generated from field: repeated string asset_ids = 1;
   */
  assetIds: string[];
};

/**
 * Describes the message assets.v3.DeleteAssetsRequest.
 * Use `create(DeleteAssetsRequestSchema)` to create a new message.
 */
export const DeleteAssetsRequestSchema: GenMessage<DeleteAssetsRequest> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 13);

/**
 * @generated from message assets.v3.DeleteAssetsResponse
 */
export type DeleteAssetsResponse = Message<"assets.v3.DeleteAssetsResponse"> & {
  /**
   * The list of deleted assets with available actions
   *
   * @generated from field: repeated assets.v3.AssetWithActions assets = 1;
   */
  assets: AssetWithActions[];

  /**
   * List of asset IDs that were not found or inaccessible
   *
   * @generated from field: repeated string not_found_asset_ids = 2;
   */
  notFoundAssetIds: string[];
};

/**
 * Describes the message assets.v3.DeleteAssetsResponse.
 * Use `create(DeleteAssetsResponseSchema)` to create a new message.
 */
export const DeleteAssetsResponseSchema: GenMessage<DeleteAssetsResponse> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 14);

/**
 * Request message for deleting an asset.
 *
 * @generated from message assets.v3.DeleteAssetRequest
 */
export type DeleteAssetRequest = Message<"assets.v3.DeleteAssetRequest"> & {
  /**
   * The ID of the asset to delete
   *
   * @generated from field: string asset_id = 1;
   */
  assetId: string;
};

/**
 * Describes the message assets.v3.DeleteAssetRequest.
 * Use `create(DeleteAssetRequestSchema)` to create a new message.
 */
export const DeleteAssetRequestSchema: GenMessage<DeleteAssetRequest> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 15);

/**
 * Response message for deleting an asset.
 *
 * @generated from message assets.v3.DeleteAssetResponse
 */
export type DeleteAssetResponse = Message<"assets.v3.DeleteAssetResponse"> & {
  /**
   * The deleted asset with available actions
   *
   * @generated from field: assets.v3.AssetWithActions asset = 1;
   */
  asset: AssetWithActions;
};

/**
 * Describes the message assets.v3.DeleteAssetResponse.
 * Use `create(DeleteAssetResponseSchema)` to create a new message.
 */
export const DeleteAssetResponseSchema: GenMessage<DeleteAssetResponse> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 16);

/**
 * Request message for searching assets.
 *
 * @generated from message assets.v3.SearchAssetsRequest
 */
export type SearchAssetsRequest = Message<"assets.v3.SearchAssetsRequest"> & {
  /**
   * The search query string
   *
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * The maximum number of assets to return
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * The next_page_token value returned from a previous Search request, if any
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;

  /**
   * Optional filter by lifecycle state
   *
   * @generated from field: repeated assets.v3.AssetLifecycleState lifecycle_states = 4;
   */
  lifecycleStates: AssetLifecycleState[];

  /**
   * Optional filter by organization ID
   *
   * @generated from field: string organization_id = 5;
   */
  organizationId: string;

  /**
   * Optional filter by content type
   *
   * @generated from field: repeated string content_types = 6;
   */
  contentTypes: string[];
};

/**
 * Describes the message assets.v3.SearchAssetsRequest.
 * Use `create(SearchAssetsRequestSchema)` to create a new message.
 */
export const SearchAssetsRequestSchema: GenMessage<SearchAssetsRequest> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 17);

/**
 * Response message for searching assets.
 *
 * @generated from message assets.v3.SearchAssetsResponse
 */
export type SearchAssetsResponse = Message<"assets.v3.SearchAssetsResponse"> & {
  /**
   * The list of matching assets with their available actions
   *
   * @generated from field: repeated assets.v3.AssetWithActions assets = 1;
   */
  assets: AssetWithActions[];

  /**
   * Token to retrieve the next page of results
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message assets.v3.SearchAssetsResponse.
 * Use `create(SearchAssetsResponseSchema)` to create a new message.
 */
export const SearchAssetsResponseSchema: GenMessage<SearchAssetsResponse> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 18);

/**
 * Request message for reprocessing an asset.
 *
 * @generated from message assets.v3.ReprocessAssetRequest
 */
export type ReprocessAssetRequest = Message<"assets.v3.ReprocessAssetRequest"> & {
  /**
   * The ID of the asset to reprocess
   *
   * @generated from field: string asset_id = 1;
   */
  assetId: string;
};

/**
 * Describes the message assets.v3.ReprocessAssetRequest.
 * Use `create(ReprocessAssetRequestSchema)` to create a new message.
 */
export const ReprocessAssetRequestSchema: GenMessage<ReprocessAssetRequest> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 19);

/**
 * Response message for reprocessing an asset.
 *
 * @generated from message assets.v3.ReprocessAssetResponse
 */
export type ReprocessAssetResponse = Message<"assets.v3.ReprocessAssetResponse"> & {
  /**
   * The asset that was queued for reprocessing
   *
   * @generated from field: assets.v3.AssetWithActions asset = 1;
   */
  asset: AssetWithActions;
};

/**
 * Describes the message assets.v3.ReprocessAssetResponse.
 * Use `create(ReprocessAssetResponseSchema)` to create a new message.
 */
export const ReprocessAssetResponseSchema: GenMessage<ReprocessAssetResponse> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 20);

/**
 * Request message for uploading file data directly to an asset.
 *
 * @generated from message assets.v3.UploadAssetRequest
 */
export type UploadAssetRequest = Message<"assets.v3.UploadAssetRequest"> & {
  /**
   * The ID of the asset to upload data to
   *
   * @generated from field: string asset_id = 1;
   */
  assetId: string;

  /**
   * The file data as bytes
   *
   * @generated from field: bytes file_data = 2;
   */
  fileData: Uint8Array;

  /**
   * MD5 hash of the file for integrity checking
   *
   * @generated from field: string md5_hash = 3;
   */
  md5Hash: string;

  /**
   * Content type of the file
   *
   * @generated from field: string content_type = 4;
   */
  contentType: string;

  /**
   * Chunk information for large file uploads
   *
   * @generated from field: optional assets.v3.ChunkInfo chunk_info = 5;
   */
  chunkInfo: ChunkInfo;
};

/**
 * Describes the message assets.v3.UploadAssetRequest.
 * Use `create(UploadAssetRequestSchema)` to create a new message.
 */
export const UploadAssetRequestSchema: GenMessage<UploadAssetRequest> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 21);

/**
 * Response message for uploading file data.
 *
 * @generated from message assets.v3.UploadAssetResponse
 */
export type UploadAssetResponse = Message<"assets.v3.UploadAssetResponse"> & {
  /**
   * The updated asset with available actions
   *
   * @generated from field: assets.v3.AssetWithActions asset = 1;
   */
  asset: AssetWithActions;

  /**
   * Upload progress information
   *
   * @generated from field: assets.v3.UploadProgress progress = 2;
   */
  progress: UploadProgress;

  /**
   * Whether the upload is complete or if more chunks are expected
   *
   * @generated from field: bool upload_complete = 3;
   */
  uploadComplete: boolean;
};

/**
 * Describes the message assets.v3.UploadAssetResponse.
 * Use `create(UploadAssetResponseSchema)` to create a new message.
 */
export const UploadAssetResponseSchema: GenMessage<UploadAssetResponse> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 22);

/**
 * Request message for completing a signed URL upload.
 *
 * @generated from message assets.v3.CompleteAssetUploadRequest
 */
export type CompleteAssetUploadRequest = Message<"assets.v3.CompleteAssetUploadRequest"> & {
  /**
   * The ID of the asset that was uploaded
   *
   * @generated from field: string asset_id = 1;
   */
  assetId: string;

  /**
   * MD5 hash of the uploaded file for verification
   *
   * @generated from field: string md5_hash = 2;
   */
  md5Hash: string;

  /**
   * Optional file size for verification
   *
   * @generated from field: optional int64 file_size = 3;
   */
  fileSize: bigint;
};

/**
 * Describes the message assets.v3.CompleteAssetUploadRequest.
 * Use `create(CompleteAssetUploadRequestSchema)` to create a new message.
 */
export const CompleteAssetUploadRequestSchema: GenMessage<CompleteAssetUploadRequest> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 23);

/**
 * Response message for completing an asset upload.
 *
 * @generated from message assets.v3.CompleteAssetUploadResponse
 */
export type CompleteAssetUploadResponse = Message<"assets.v3.CompleteAssetUploadResponse"> & {
  /**
   * The updated asset with available actions
   *
   * @generated from field: assets.v3.AssetWithActions asset = 1;
   */
  asset: AssetWithActions;
};

/**
 * Describes the message assets.v3.CompleteAssetUploadResponse.
 * Use `create(CompleteAssetUploadResponseSchema)` to create a new message.
 */
export const CompleteAssetUploadResponseSchema: GenMessage<CompleteAssetUploadResponse> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 24);

/**
 * Information about a file chunk for streaming uploads.
 *
 * @generated from message assets.v3.ChunkInfo
 */
export type ChunkInfo = Message<"assets.v3.ChunkInfo"> & {
  /**
   * Chunk sequence number (0-based)
   *
   * @generated from field: int32 chunk_number = 1;
   */
  chunkNumber: number;

  /**
   * Total number of chunks
   *
   * @generated from field: int32 total_chunks = 2;
   */
  totalChunks: number;

  /**
   * Size of this chunk in bytes
   *
   * @generated from field: int64 chunk_size = 3;
   */
  chunkSize: bigint;

  /**
   * Total file size in bytes
   *
   * @generated from field: int64 total_size = 4;
   */
  totalSize: bigint;
};

/**
 * Describes the message assets.v3.ChunkInfo.
 * Use `create(ChunkInfoSchema)` to create a new message.
 */
export const ChunkInfoSchema: GenMessage<ChunkInfo> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 25);

/**
 * Upload progress information.
 *
 * @generated from message assets.v3.UploadProgress
 */
export type UploadProgress = Message<"assets.v3.UploadProgress"> & {
  /**
   * Total bytes uploaded so far
   *
   * @generated from field: int64 bytes_uploaded = 1;
   */
  bytesUploaded: bigint;

  /**
   * Total file size in bytes
   *
   * @generated from field: int64 total_bytes = 2;
   */
  totalBytes: bigint;

  /**
   * Upload percentage (0-100)
   *
   * @generated from field: double percentage = 3;
   */
  percentage: number;
};

/**
 * Describes the message assets.v3.UploadProgress.
 * Use `create(UploadProgressSchema)` to create a new message.
 */
export const UploadProgressSchema: GenMessage<UploadProgress> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 26);

/**
 * Job status information for an asset.
 *
 * @generated from message assets.v3.AssetJobStatus
 */
export type AssetJobStatus = Message<"assets.v3.AssetJobStatus"> & {
  /**
   * The asset ID
   *
   * @generated from field: string asset_id = 1;
   */
  assetId: string;

  /**
   * Current job ID (if any)
   *
   * @generated from field: optional string current_job_id = 2;
   */
  currentJobId: string;

  /**
   * Current job status
   *
   * @generated from field: optional string job_status = 3;
   */
  jobStatus: string;

  /**
   * Asset lifecycle state
   *
   * @generated from field: assets.v3.AssetLifecycleState lifecycle_state = 4;
   */
  lifecycleState: AssetLifecycleState;

  /**
   * When processing started
   *
   * @generated from field: optional google.protobuf.Timestamp processing_started_at = 5;
   */
  processingStartedAt: Timestamp;

  /**
   * When processing completed
   *
   * @generated from field: optional google.protobuf.Timestamp processing_completed_at = 6;
   */
  processingCompletedAt: Timestamp;

  /**
   * Processing duration in seconds
   *
   * @generated from field: optional int32 processing_duration_seconds = 7;
   */
  processingDurationSeconds: number;

  /**
   * Number of job failures
   *
   * @generated from field: optional int32 job_failure_count = 8;
   */
  jobFailureCount: number;

  /**
   * Last failure reason
   *
   * @generated from field: optional string last_job_failure_reason = 9;
   */
  lastJobFailureReason: string;

  /**
   * Text token count
   *
   * @generated from field: optional int32 text_tokens = 10;
   */
  textTokens: number;

  /**
   * Whether embeddings were generated
   *
   * @generated from field: optional bool embeddings_generated = 11;
   */
  embeddingsGenerated: boolean;
};

/**
 * Describes the message assets.v3.AssetJobStatus.
 * Use `create(AssetJobStatusSchema)` to create a new message.
 */
export const AssetJobStatusSchema: GenMessage<AssetJobStatus> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 27);

/**
 * Request message for getting asset job status.
 *
 * @generated from message assets.v3.GetAssetJobStatusRequest
 */
export type GetAssetJobStatusRequest = Message<"assets.v3.GetAssetJobStatusRequest"> & {
  /**
   * The ID of the asset to get job status for
   *
   * @generated from field: string asset_id = 1;
   */
  assetId: string;
};

/**
 * Describes the message assets.v3.GetAssetJobStatusRequest.
 * Use `create(GetAssetJobStatusRequestSchema)` to create a new message.
 */
export const GetAssetJobStatusRequestSchema: GenMessage<GetAssetJobStatusRequest> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 28);

/**
 * Response message for getting asset job status.
 *
 * @generated from message assets.v3.GetAssetJobStatusResponse
 */
export type GetAssetJobStatusResponse = Message<"assets.v3.GetAssetJobStatusResponse"> & {
  /**
   * The asset job status
   *
   * @generated from field: assets.v3.AssetJobStatus job_status = 1;
   */
  jobStatus: AssetJobStatus;
};

/**
 * Describes the message assets.v3.GetAssetJobStatusResponse.
 * Use `create(GetAssetJobStatusResponseSchema)` to create a new message.
 */
export const GetAssetJobStatusResponseSchema: GenMessage<GetAssetJobStatusResponse> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 29);

/**
 * Request message for getting bulk asset job status.
 *
 * @generated from message assets.v3.GetBulkAssetJobStatusRequest
 */
export type GetBulkAssetJobStatusRequest = Message<"assets.v3.GetBulkAssetJobStatusRequest"> & {
  /**
   * List of asset IDs to get job status for (max 100)
   *
   * @generated from field: repeated string asset_ids = 1;
   */
  assetIds: string[];
};

/**
 * Describes the message assets.v3.GetBulkAssetJobStatusRequest.
 * Use `create(GetBulkAssetJobStatusRequestSchema)` to create a new message.
 */
export const GetBulkAssetJobStatusRequestSchema: GenMessage<GetBulkAssetJobStatusRequest> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 30);

/**
 * Response message for getting bulk asset job status.
 *
 * @generated from message assets.v3.GetBulkAssetJobStatusResponse
 */
export type GetBulkAssetJobStatusResponse = Message<"assets.v3.GetBulkAssetJobStatusResponse"> & {
  /**
   * List of asset job statuses
   *
   * @generated from field: repeated assets.v3.AssetJobStatus job_statuses = 1;
   */
  jobStatuses: AssetJobStatus[];
};

/**
 * Describes the message assets.v3.GetBulkAssetJobStatusResponse.
 * Use `create(GetBulkAssetJobStatusResponseSchema)` to create a new message.
 */
export const GetBulkAssetJobStatusResponseSchema: GenMessage<GetBulkAssetJobStatusResponse> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset_service, 31);

/**
 * AssetService provides operations for managing assets within the platform.
 *
 * @generated from service assets.v3.AssetService
 */
export const AssetService: GenService<{
  /**
   * CreateAsset creates a new asset record for upload.
   *
   * @generated from rpc assets.v3.AssetService.CreateAsset
   */
  createAsset: {
    methodKind: "unary";
    input: typeof CreateAssetRequestSchema;
    output: typeof CreateAssetResponseSchema;
  },
  /**
   * GetAsset retrieves a specific asset by ID.
   *
   * @generated from rpc assets.v3.AssetService.GetAsset
   */
  getAsset: {
    methodKind: "unary";
    input: typeof GetAssetRequestSchema;
    output: typeof GetAssetResponseSchema;
  },
  /**
   * GetAssets retrieves multiple assets by their IDs.
   *
   * @generated from rpc assets.v3.AssetService.GetAssets
   */
  getAssets: {
    methodKind: "unary";
    input: typeof GetAssetsRequestSchema;
    output: typeof GetAssetsResponseSchema;
  },
  /**
   * ListAssets retrieves a paginated list of assets.
   *
   * @generated from rpc assets.v3.AssetService.ListAssets
   */
  listAssets: {
    methodKind: "unary";
    input: typeof ListAssetsRequestSchema;
    output: typeof ListAssetsResponseSchema;
  },
  /**
   * UpdateAsset updates an existing asset.
   *
   * @generated from rpc assets.v3.AssetService.UpdateAsset
   */
  updateAsset: {
    methodKind: "unary";
    input: typeof UpdateAssetRequestSchema;
    output: typeof UpdateAssetResponseSchema;
  },
  /**
   * DeleteAsset marks an asset for deletion.
   *
   * @generated from rpc assets.v3.AssetService.DeleteAsset
   */
  deleteAsset: {
    methodKind: "unary";
    input: typeof DeleteAssetRequestSchema;
    output: typeof DeleteAssetResponseSchema;
  },
  /**
   * @generated from rpc assets.v3.AssetService.DeleteAssets
   */
  deleteAssets: {
    methodKind: "unary";
    input: typeof DeleteAssetsRequestSchema;
    output: typeof DeleteAssetsResponseSchema;
  },
  /**
   * SearchAssets allows searching for assets based on various criteria.
   *
   * @generated from rpc assets.v3.AssetService.SearchAssets
   */
  searchAssets: {
    methodKind: "unary";
    input: typeof SearchAssetsRequestSchema;
    output: typeof SearchAssetsResponseSchema;
  },
  /**
   * ReprocessAsset triggers reprocessing of an asset.
   *
   * @generated from rpc assets.v3.AssetService.ReprocessAsset
   */
  reprocessAsset: {
    methodKind: "unary";
    input: typeof ReprocessAssetRequestSchema;
    output: typeof ReprocessAssetResponseSchema;
  },
  /**
   * UploadAsset uploads file data directly to the asset.
   *
   * @generated from rpc assets.v3.AssetService.UploadAsset
   */
  uploadAsset: {
    methodKind: "unary";
    input: typeof UploadAssetRequestSchema;
    output: typeof UploadAssetResponseSchema;
  },
  /**
   * CompleteAssetUpload notifies that a signed URL upload is complete.
   *
   * @generated from rpc assets.v3.AssetService.CompleteAssetUpload
   */
  completeAssetUpload: {
    methodKind: "unary";
    input: typeof CompleteAssetUploadRequestSchema;
    output: typeof CompleteAssetUploadResponseSchema;
  },
  /**
   * GetAssetJobStatus retrieves the current job status for a single asset.
   *
   * @generated from rpc assets.v3.AssetService.GetAssetJobStatus
   */
  getAssetJobStatus: {
    methodKind: "unary";
    input: typeof GetAssetJobStatusRequestSchema;
    output: typeof GetAssetJobStatusResponseSchema;
  },
  /**
   * GetBulkAssetJobStatus retrieves job status for multiple assets.
   *
   * @generated from rpc assets.v3.AssetService.GetBulkAssetJobStatus
   */
  getBulkAssetJobStatus: {
    methodKind: "unary";
    input: typeof GetBulkAssetJobStatusRequestSchema;
    output: typeof GetBulkAssetJobStatusResponseSchema;
  },
  /**
   * @generated from rpc assets.v3.AssetService.GenerateSignedURL
   */
  generateSignedURL: {
    methodKind: "unary";
    input: typeof GenerateSignedURLRequestSchema;
    output: typeof GenerateSignedURLResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_assets_v3_asset_service, 0);

